import React, { useCallback, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  CircularProgress,
  Stack,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import {
  apiErrorToast,
  okSuccessToast,
  okSuccessToastsm,
} from "../../utils/ToastUtil";
import ModalHeader from "../../modals/ModalHeader";
import Loader from "../../component/loading-screen/Loader";
import ModalFooter from "../../modals/ModalFooter";
import DeleteIcon from '@mui/icons-material/Delete';
import Spinner from "../../component/loading-screen/Spinner";
const DeleteCustomer = ({ user, refresh, iconColor }) => {
  const [open, setOpen] = useState(false);
  const [updaLoading, setUpdateLoading] = useState(false);

  const [formData, setFormData] = useState({
    id: user.id || "",
    name: user.name || "",
    gender: user.gender || "",
    username: user.username || "",
    mobile: user.mobile || "",
    email: user.email || "",
    password: "",
    role: user.role || "",
    status: user.status || "",
  });

  const handleOpen = () => {
    setFormData({
      id: user.id || "",
      name: user.name || "",
      gender: user.gender || "",
      username: user.username || "",
      mobile: user.mobile || "",
      email: user.email || "",
      password: "",
      role: user.role || "",
      status: user.status || "",
    });
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const deleteUser = useCallback(async () => {
    setUpdateLoading(true);

    postJsonData(
      `${ApiEndpoints.DELETE_USERS_BIGG}/${user.id}`,
      formData,
      setUpdateLoading,
      (res) => {
        okSuccessToast(res.data.message || "Customer Deleted Sucessfully");
        setUpdateLoading(false);
        setOpen(false);
        refresh();
      },
      (error) => {
        apiErrorToast(error);
        setOpen(false);
      }
    );
  }, [user.id, formData, refresh]);

  const handleSubmit = (e) => {
    e.preventDefault();
    deleteUser();
  };

  return (
    <>
      <IconButton onClick={handleOpen}>
  <DeleteIcon sx={{ width:"20px",height:"20px", color: iconColor || "red" }} />
</IconButton>


      <Modal open={open} onClose={handleClose}>
        <Box
        
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <Spinner loading={updaLoading} />
          <ModalHeader
            title="Delete Customer"
            handleClose={handleClose}
            subtitle="Easily  Delete Customer"
          />
          <Typography variant="body1" sx={{ mt: 2 }}>
            Are you sure you want to delete this user? {formData.name}
          </Typography>

          <Box>
            <ModalFooter
              form="delete-customer"
              request={updaLoading}
              btn="Delete Customer"
              onClick={handleSubmit}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeleteCustomer;
